import { Inject, Injectable } from '@angular/core';
import { SESSION_STORAGE, StorageService } from 'angular-webstorage-service';
import { AppStorage } from '../models/app-storage';

const APP_STORAGE_KEY = 'phibor';

@Injectable()
export class AppStorageService {

    constructor(
        @Inject(SESSION_STORAGE) private storage: StorageService
    ) {
//        this.set(<AppStorage> {
//            searchEdition: {
//                'params': null,
//                'cache': null,
//                'selected': null
//            }
//        });
    }

    public set(storageData: AppStorage): void {
        return this.storage.set(APP_STORAGE_KEY, storageData);
    }

    public get(): AppStorage {
        return this.storage.get(APP_STORAGE_KEY);
    }

    public remove(): void {
        return this.storage.remove(APP_STORAGE_KEY);
    }

}



// WEBPACK FOOTER //
// ./src/app/services/app-storage.service.ts